import React, { useState, useCallback } from "react";
import { Container, HeaderRow, ArrowWrapper, List, ListItem } from "./AgentsList.styled";
import { Icon, Typography } from "@ann/web-components";

const MOCK_AGENTS = [
  "Strategy Assistant",
  "Knowledge Agent",
  "Research Helper",
  "Support agent",
  "Personal Assistant",
  "Operations agent",
];

const AgentsList = ({ selectedAgentId, onSelectAgent }) => {
  const [isExpanded, setIsExpanded] = useState(true);

  const handleToggle = useCallback(() => {
    setIsExpanded((prev) => !prev);
  }, []);

  const handleSelectAgent = useCallback(
    (agent) => {
      onSelectAgent?.(agent);
    },
    [onSelectAgent]
  );

  return (
    <Container>
      <HeaderRow type="button" onClick={handleToggle}>
        <Typography
          category="subtitle"
          size="small"
          weight="bold"
        >
          Agents
        </Typography>
        <ArrowWrapper $isExpanded={isExpanded}>
          <Icon name="chevronRight" size="medium" color="neutral" />
        </ArrowWrapper>
      </HeaderRow>

      <List $isExpanded={isExpanded}>
        {MOCK_AGENTS.map((agent, index) => (
          <ListItem
            key={index}
            onClick={() => handleSelectAgent(agent)}
            $isSelected={selectedAgentId === agent}
          >
            <Typography category="body" size="medium" weight="regular" color="body">
              {agent}
            </Typography>
          </ListItem>
        ))}
      </List>
    </Container>
  );
};

export default AgentsList;
